import React from "react";
import { Alert as AntdAlert } from "antd";
import type { AlertProps as AntdAlertProps } from "antd";

type AlertProps = {
  message?: string;
  description?: React.ReactNode;
  actionText?: string;
  actionOnClick?: () => void;
  actionLink?: string;
  type: "info" | "success" | "warning" | "error";
  style?: React.CSSProperties;
} & Pick<AntdAlertProps, "closable" | "showIcon" | "banner" | "onClose">;

const Alert = ({
  message,
  description,
  actionText,
  actionOnClick,
  actionLink,
  type,
  style,
  closable,
  onClose,
  banner,
  showIcon = true,
}: AlertProps) => {
  return (
    <AntdAlert
      style={{ padding: "12px 12px", ...style }}
      message={message}
      description={
        (description || actionText) && (
          <div
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
          >
            {description && (
              <div style={{ alignSelf: "left", margin: "0px" }}>{description}</div>
            )}
            {actionText && (
              <a
                href={actionLink}
                style={{ alignSelf: "right", marginLeft: "auto" }}
                onClick={actionOnClick}
              >
                {actionText}
              </a>
            )}
          </div>
        )
      }
      type={type}
      showIcon={showIcon}
      closable={closable}
      onClose={onClose}
      banner={banner}
    />
  );
};

export default Alert;
